import {EMPTY, ObservableInput, ObservedValueOf, OperatorFunction} from 'rxjs';
import {concatMap, map, tap} from 'rxjs/operators';

/** A concatMap that buffers values in between. */
export function concatMapLatest<T, O extends ObservableInput<any>>(
  project: (values: ReadonlyArray<T>) => O,
): OperatorFunction<T, ObservedValueOf<O>> {
  return (source$) => {
    let latestIndex = -1;
    let pendingItems: Array<T> = [];

    return source$.pipe(
      tap(() => {
        latestIndex += 1;
      }),
      map((value) => ({
        index: latestIndex,
        value,
      })),
      concatMap(({index, value}) => {
        if (index !== latestIndex) {
          // If this isn't the latest item, skip projection, but store it in a queue.
          pendingItems.push(value);
          return EMPTY;
        }

        // Project the collected items and clear the queue.
        const observable = project([...pendingItems, value]);
        pendingItems = [];
        return observable;
      }),
    );
  };
}
